// Payback calculator. Every figure is derived from the three inputs — no lookup tables,
// no rounding that flatters the result. The plan tiers mirror the pricing page exactly:
// change one and change the other.
(function () {
  var WEEKS_PER_MONTH = 4.33;
  var HOURS_PER_WEEK = 40;
  var PLANS = [
    { max: 1, name: 'Single Bay', price: 199 },
    { max: 4, name: 'Mid-Sized Shop', price: 349.99 },
    { max: Infinity, name: 'Large-Scale Shop', price: 499.99 },
  ];

  function money(n, dp) {
    return '$' + n.toLocaleString('en-US', {
      minimumFractionDigits: dp === undefined ? 0 : dp,
      maximumFractionDigits: dp === undefined ? 0 : dp,
    });
  }

  function init(root) {
    if (root.dataset.swCalcReady) return;
    root.dataset.swCalcReady = '1';

    var techs = root.querySelector('[data-calc-techs]');
    var rate = root.querySelector('[data-calc-rate]');
    var lost = root.querySelector('[data-calc-lost]');
    if (!techs || !rate || !lost) return;

    var out = {
      techs: document.getElementById(techs.id + '-out'),
      rate: document.getElementById(rate.id + '-out'),
      lost: document.getElementById(lost.id + '-out'),
      money: root.querySelector('[data-calc-money]'),
      hours: root.querySelector('[data-calc-hours]'),
      plan: root.querySelector('[data-calc-plan]'),
      planName: root.querySelector('[data-calc-planname]'),
      breakeven: root.querySelector('[data-calc-breakeven]'),
      breakeven2: root.querySelector('[data-calc-breakeven-2]'),
      billed: root.querySelector('[data-calc-billed]'),
    };

    function render() {
      var t = +techs.value;
      var r = +rate.value;
      var l = +lost.value;

      var hoursPerMonth = t * l * WEEKS_PER_MONTH;
      var dollars = hoursPerMonth * r;
      var plan = PLANS.find(function (p) { return t <= p.max; });
      // Hours of recovered labor needed to cover the subscription.
      var breakeven = plan.price / r;

      if (out.techs) out.techs.textContent = String(t);
      if (out.rate) out.rate.textContent = money(r);
      if (out.lost) out.lost.textContent = l.toFixed(1);
      if (out.money) out.money.textContent = money(dollars);
      if (out.hours) out.hours.textContent = hoursPerMonth.toFixed(0);
      if (out.plan) out.plan.textContent = money(plan.price, plan.price % 1 ? 2 : 0);
      if (out.planName) out.planName.textContent = plan.name;
      if (out.breakeven) out.breakeven.textContent = breakeven.toFixed(1) + 'h';
      if (out.breakeven2) out.breakeven2.textContent = breakeven.toFixed(1);
      // The slider is hours lost; what a shop owner actually recognises is the percentage of a
      // paid week that reaches an invoice. Showing it live is what stops the low end of the
      // control reading as a reasonable place to leave the slider.
      if (out.billed) out.billed.textContent = String(Math.round(((HOURS_PER_WEEK - l) / HOURS_PER_WEEK) * 100));

      // Fill the track to the left of the thumb, so the control reads as a gauge.
      [techs, rate, lost].forEach(function (el) {
        var pct = ((el.value - el.min) / (el.max - el.min)) * 100;
        el.style.setProperty('--sw-fill', pct + '%');
      });

      // A screen reader announcing "150" for a labour rate is useless — give each
      // slider the same text a sighted person reads off the control.
      techs.setAttribute('aria-valuetext', t + (t === 1 ? ' technician' : ' technicians'));
      rate.setAttribute('aria-valuetext', money(r) + ' per billed hour');
      lost.setAttribute('aria-valuetext', l.toFixed(1) + ' hours lost per tech per week, '
        + Math.round(((HOURS_PER_WEEK - l) / HOURS_PER_WEEK) * 100) + ' percent of a 40-hour week billed');
    }

    [techs, rate, lost].forEach(function (el) {
      el.addEventListener('input', render);
      el.addEventListener('change', render);
    });
    render();
  }

  function boot() { document.querySelectorAll('[data-sw-calc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
